import React from "react";
import CanvasInput from "../addCanvas/canvasInput";

const Sku = ({ product, setProduct }) => {
  const handleField = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };
  return (
    <>
      <h3 className="fw-300 mt-10 mb-10">SKU:</h3>
      <CanvasInput
        name="sku"
        type="text"
        value={product.sku}
        onChange={handleField}
        placeholder="Product SKU"
      />
    </>
  );
};

export default Sku;
